import { createUseStyles } from 'react-jss';
import { Spacings } from '@picsart/design-system/foundation/spacings';

const useStyles = createUseStyles(
  {
    container: {
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      overflowY: 'auto',
      paddingInline: Spacings.s16,
      paddingTop: Spacings.s16,
      paddingBottom: Spacings.s24,
    },
    grid: {
      display: 'grid',
      gap: Spacings.s8,
    },
    cell: {
      aspectRatio: '3 / 4',
    },
  },
  { name: 'SeeAllCategory' }
);

export default useStyles;
